import { render, staticRenderFns } from "./RepuestosRecibidosEjecutivo.vue?vue&type=template&id=e28d4ab8&scoped=true&lang=pug"
import script from "./RepuestosRecibidosEjecutivo.vue?vue&type=script&lang=js"
export * from "./RepuestosRecibidosEjecutivo.vue?vue&type=script&lang=js"
import style0 from "./RepuestosRecibidosEjecutivo.vue?vue&type=style&index=0&id=e28d4ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28d4ab8",
  null
  
)

export default component.exports